import { render } from "./FollowedProjects.vue?vue&type=template&id=a29aa9ac"
import script from "./FollowedProjects.vue?vue&type=script&lang=js"
export * from "./FollowedProjects.vue?vue&type=script&lang=js"

import "./FollowedProjects.vue?vue&type=style&index=0&id=a29aa9ac&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__